import React from 'react';

import { Typography } from '@mui/material';

import { formattedShortDate } from '@luxuryescapes/lib-refunds/build/lib/formatDate';

import { formatDateLong, formatDateLongMonthWithMeridiem, formatDateWithClock } from '~/services/TimeService';

const getDateColor = (date: Date) => (date > new Date() ? 'grey.800' : 'red');

type Props = {
  date: string;
  highlightIfPast?: boolean | 'green';
  includeYear?: boolean;
  includeTime?: boolean;
};

const getHighlightIfPastColor = (highlightIfPast: boolean | 'green', date: Date) => {
  if (highlightIfPast === 'green') {
    return 'green';
  }
  return highlightIfPast ? getDateColor(date) : '';
};

const DateFormatterDetailed = ({ date, highlightIfPast = false, includeYear = false, includeTime = false }: Props) => {
  if (!date) {
    return null;
  }

  const dateValue = new Date(date);
  let displayDate = formattedShortDate(dateValue);
  if (includeYear) {
    displayDate = formatDateLong(dateValue);
  }
  if (includeTime) {
    displayDate = formatDateWithClock(dateValue);
  }

  return (
    <Typography
      variant="caption"
      color={highlightIfPast ? getHighlightIfPastColor(highlightIfPast, dateValue) : ''}
      title={formatDateLongMonthWithMeridiem(dateValue)}
    >
      {displayDate}
    </Typography>
  );
};

export default DateFormatterDetailed;
